export const STATUS_APPLICATIONS = [
  { value: 'applied', label: 'Applied' },
  { value: 'documentPassed', label: 'Document Screening Passed' },
  { value: 'documentFailed', label: 'Document Screening Failed' },
  { value: 'selected', label: 'Selected' },
  { value: 'pending', label: 'Pending' },
  { value: 'rejected', label: 'Rejected' }
]; 